import React from "react";
import { Form } from "react-bootstrap";

const SimpleTableField = ({ placeholder = "", value, setValue, ...props }) => {
    return (
        <>
            <td>
                <Form.Control
                    value={value}
                    onChange={(e) => setValue(e.currentTarget.value)}
                    placeholder={placeholder}
                    {...props}
                />
            </td>
        </>
    );
};

export default SimpleTableField;
